import React from 'react'
import { Container, Form, Button, Image, Row, Col, Nav, NavDropdown, Card } from 'react-bootstrap';
import { getAuth, signOut } from "firebase/auth";
import SideNav from '../components/SideNav';
import { OrderSummaryCards } from './OrderPage';
import Topbar from '../components/Topbar';
import NotificationDropdown from '../components/NotificationDropdown'; // New notification component

import InProgres from '../components/InProgres';


function MyTask() {

    const userUId = window.localStorage.getItem('projectUserUID');
    const userRole = window.localStorage.getItem('projectUserRole');


  return (
    <Container fluid className='p-3' style={{ backgroundColor: "#F9FAFB", height: "100vh", }}>
    <Row>
        <Col className='col-auto'>
           <SideNav />
        </Col>
        <Col style={{ padding: "0px 10px 0px 20px",flexGrow:1}}>
            <Row className='p-2' style={{ backgroundColor: "#fff", borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween" }}>
                <Col><h4 style={{ color: "#000" }}>My Task</h4></Col>
                <Col className="d-flex justify-content-end align-items-center">
                {/* <NotificationDropdown userId={userUId} /> */}
                    {/* <Image src={require('../assets/notification.png')} roundedCircle style={{ width: '25px', height: 'auto', marginRight: '5px', }} /> */}
                    <Image src={require('../assets/user.jpg')} roundedCircle style={{ width: '40px', height: 'auto' }} />
                </Col>
            </Row>
            <Row className='p-2 mt-2' style={{ backgroundColor: "#fff", borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween" }}>
               {/* Main Body Part */}
           <InProgres userId={userUId} role={userRole} />
            </Row>

        </Col>
    </Row>
</Container>
  ) 
}

export default MyTask